(function(){
var root=document.getElementById('prForm');if(!root)return;
var VARIANTS=window.PR_PDP.variants;
var SELECTED=null;
function eur(cents){return '£'+(cents/100).toFixed(2);}
function prParse(s){if(!s)return 0;return parseFloat((''+s).replace(/[^0-9.]/g,''))||0;}
function prKlCents(){return (SELECTED&&SELECTED.price)?Math.round(prParse(SELECTED.price)*100):current().pa;}
function prUpdateKl(){var t=eur(prKlCents()/3);['prKl','prKl2','prKl3'].forEach(function(id){var k=document.getElementById(id);if(k)k.textContent=t;});}
function selected(){var vals=[];root.querySelectorAll('.pr-opt').forEach(function(o){var c=o.querySelector('input:checked');if(c)vals.push(c.value);});return vals;}
function current(){var id=parseInt(document.getElementById('prVariantId').value);return VARIANTS.find(function(x){return x.id===id;})||VARIANTS[0];}
function setCtaPrice(txt){var e=document.getElementById('prAtcPrice');if(e)e.textContent=txt?(' · '+txt):'';}
function update(){
var vals=selected();if(!vals.length){return;}
var m=VARIANTS.find(function(x){return x.opts.length===vals.length&&x.opts.every(function(o,i){return o===vals[i];});});
if(!m)return;
document.getElementById('prVariantId').value=m.id;
document.getElementById('prPrice').textContent=m.price;
prUpdateKl();
if(!SELECTED){var atc=document.getElementById('prAtc');if(m.avail){atc.disabled=false;atc.classList.remove('sold');document.getElementById('prAtcText').textContent=window.PR_PDP.atc;}else{atc.disabled=true;atc.classList.add('sold');document.getElementById('prAtcText').textContent=window.PR_PDP.sold;}}
}
window.prSelectOffer=function(el){
var wrap=document.getElementById('prOffers');
wrap.querySelectorAll('.pr-pdp__offer').forEach(function(x){x.classList.remove('is-selected');});
el.classList.add('is-selected');
var vs=(el.getAttribute('data-variants')||'').split(',').filter(Boolean);
SELECTED={variants:vs,price:el.getAttribute('data-price')};
setCtaPrice(SELECTED.price);prUpdateKl();
};
root.querySelectorAll('input[type=radio]').forEach(function(r){r.addEventListener('change',function(){root.querySelectorAll('.pr-opt__v').forEach(function(l){l.classList.toggle('on',l.querySelector('input').checked);});update();});});
var prSlides=document.getElementById('prSlides');
var thumbs=document.getElementById('prThumbs');
function prSetMedia(i){
if(!thumbs)return;
var btns=thumbs.querySelectorAll('button');
btns.forEach(function(b,bi){b.classList.toggle('on',bi===i);});
var act=btns[i];
if(act){var target=act.offsetLeft-(thumbs.clientWidth-act.offsetWidth)/2;thumbs.scrollTo({left:Math.max(0,target),behavior:'smooth'});}
}
if(thumbs&&prSlides){thumbs.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;var i=parseInt(b.dataset.i)||0;prSlides.scrollTo({left:i*prSlides.clientWidth,behavior:'smooth'});prSetMedia(i);});}
if(prSlides){var prST;prSlides.addEventListener('scroll',function(){clearTimeout(prST);prST=setTimeout(function(){prSetMedia(Math.round(prSlides.scrollLeft/prSlides.clientWidth));},60);},{passive:true});}
window.prQty=function(d){var i=document.getElementById('prQty');i.value=Math.max(1,(parseInt(i.value)||1)+d);};
root.addEventListener('submit',function(e){
e.preventDefault();e.stopPropagation();
var qty=parseInt(document.getElementById('prQty').value)||1;
var items;
if(SELECTED&&SELECTED.variants.length){items=SELECTED.variants.map(function(id){return {id:parseInt(id),quantity:qty};});}
else{items=[{id:parseInt(document.getElementById('prVariantId').value),quantity:qty}];}
var btn=document.getElementById('prAtc');btn.disabled=true;
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}).then(function(r){return r.json();}).then(function(json){btn.disabled=false;if(window.prCartPopupShow){window.prCartPopupShow(json);}else{window.location=window.PR_PDP.cartUrl;}}).catch(function(){btn.disabled=false;});
});
window.prKlarnaInfo=function(){var e=eur(prKlCents()/3);['prKm1','prKm2','prKm3'].forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=e;});document.getElementById('prKmodal').classList.add('open');};
window.prKlarnaClose=function(){document.getElementById('prKmodal').classList.remove('open');};
document.getElementById('prKmodal').addEventListener('click',function(e){if(e.target===this)window.prKlarnaClose();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')window.prKlarnaClose();});
var initOffer=document.querySelector('.pr-pdp__offer');
if(initOffer){window.prSelectOffer(initOffer);}
})();
